import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'; // Import Container, Row, and Col from the correct source
import { Link } from 'react-router-dom';
import Academicleft from '../Academic/Academicleft'; // You should import 'Academicleft' if it's a local component


function FeeStructureELe() {
    return (
        <>
            <section className="project-detail feestructure">
                <Container>
                    
                    <div className="row">
                        <div className="col-lg-4">
                            <div className='c-left custom-padding-color mb-4'>
                            <Academicleft activeIndex={12} />
                            </div>
                        </div>

                     <div className="col-lg-8">
                        <Row>
                            <div className="col-lg-12">
                                <div className="section-title mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                    <h3 className='titleh3'>Fee Structure</h3>
                                </div>
                            </div>

                        </Row>
                        <Row>
                            <div className="section-title text-center my-5" >
                                <h3>Fee Structure: Jan-June 2025 Semester </h3>
                            </div>
                            <Row>

                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>B.Tech </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2025/Jan_June/B_Tech_JJ25.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.Tech </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2025/Jan_June/M_Tech_JJ25.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.Sc </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2025/Jan_June/MSc_JJ25.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                
                            </Row>{/*  row */}

                            <Row className="mt-4">

                            <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.S (Research) and Ph.D </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2025/Jan_June/MS_PhD_JJ25.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>MS & PhD (Other than Jan-June 2025 Batch)</Link>
                                        </div><br />
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2025/Jan_June/MS_PhD_Jan_June_2025_New_Batch_2025.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Fee Structure – MS & PhD (New Batch 2025) </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>Master of Public Policy (MPP) </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2025/Jan_June/MPP_JJ25.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                           </Row>
                        </Row>
                           <br /><br />
                        
                        <Row>              
                           <div className="section-title text-center mb-50 " >
                                <h3>Fee Structure: July-Dec 2024 Semester </h3>
                            </div>
                            <Row>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>B.Tech </p></h4>
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/B_Tech_2024_Prep_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Preparatory</Link>
                                        </div>
                                        <div className="services-content2 mb-1">
                                        <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/B.Tech_July-Dec_2024_Except_2024_Batch_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Except 2024 Batch</Link>
                                        </div>
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/B.Tech_2024_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2024 Batch</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.Tech </p></h4>
                                        {/* <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/M.Tech.JD_2024-Except2024.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Except 2024 Batch</Link>
                                        </div> */}
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/M_Tech_2024_Sponsored_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2024 Sponsored</Link>
                                        </div>
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/M_Tech_2024_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2024 Batch</Link>
                                        </div>
                                        
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/M_Tech_2023_6_8_2024.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2023 Batch</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.S (Research) and Ph.D </p></h4>
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/MS_PhD_Jul_Dec_2024_Except_Jul_Dec_2024_batch_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Except July-Dec 2024 Batch</Link>
                                        </div>
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/MS_PhD_Jul-Dec_2024_New_Batch_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2024 July-Dec Batch</Link>
                                        </div>
                                    </div>
                                </div>
                                </Row>
                                <Row className="mt-4">
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.Sc </p></h4>
                                        {/* <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/M.Sc.JD_2024-Except2024.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Except 2024 Batch</Link>
                                        </div> */}
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/M_Sc_2024_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2024 Batch</Link>
                                        </div>
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/M_Sc_2023_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2023 Batch</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>Master of Public Policy (MPP) </p></h4>
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/MPP_2024_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2024 Batch</Link>
                                        </div>
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/MPP_2023_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2023 Batch</Link>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.S and Ph.D International</p></h4>
                                        <div className="services-content2 mb-1">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/MS_PhD_July-Dec_2024_International_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2024 July-Dec Batch</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.Tech International</p></h4>
                                        <div className="services-content2 mb-1">
                                         <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/July-Dec/M.Tech_2024_International_6_8_24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>2024 July-Dec Batch</Link> 
                                           
                                        </div>
                                    </div>
                                </div>
                            </Row>{/*  row */}
                        </Row>
                        <Row>
                            <div className="section-title text-center my-5" >
                                <h3>Fee Structure: Jan-June 2024 Semester </h3>
                            </div>
                            <Row>

                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>B.Tech </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/B.Tech_JJ24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.Tech. </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/M.Tech_JJ24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.S (Research) and Ph.D. </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/MS_Ph. D_Jan_June-_024_Combined.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                            </Row>{/*  row */}

                            <Row className="mt-4">

                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.Sc. </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/MSc_JJ24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>Master of Public Policy (MPP) </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/MPP_JJ24.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                           </Row>
                        </Row>
                           <br /><br />
                        <Row>              
                           <div className="section-title text-center mb-50 " >
                                <h3>Fee Structure: July-Dec 2023 Semester </h3>
                            </div>
                            <Row>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>B.Tech </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2023/July-Dec/B.Tech_12-7-2023.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.Tech </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2023/July-Dec/M.Tech_12-7-2023.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.S (Research) and Ph.D </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2024/MS_Ph. D_Jan_June-_024_Combined.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>M.Sc </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2023/July-Dec/M.Sc_12-7-2023.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h4><p>Master of Public Policy (MPP) </p></h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/feestructure/2023/July-Dec/MPP_12-7-2023.pdf" target="_blank;" className="c-link"><i class="fas fa-file-pdf me-2"></i>Click here</Link>
                                        </div>
                                    </div>
                                </div>
                            </Row>{/*  row */}
                        </Row>
                     </div>  
                    </div>
                </Container>  {/*  container */}
            </section>
        </>
    )
}

export default FeeStructureELe;
